import { useCallback, useEffect, useRef, useState } from 'react';
import { usePowerSyncDb } from '../adapters/powersync';

export interface UploadQueueInfo {
  count: number;
  hasPending: boolean;
}

const POLL_INTERVAL_MS = 2_000;

export function useUploadQueueStats(): UploadQueueInfo {
  const { db } = usePowerSyncDb();
  const [info, setInfo] = useState<UploadQueueInfo>({ count: 0, hasPending: false });
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const poll = useCallback(async () => {
    if (!db) return;
    try {
      const stats = await db.getUploadQueueStats();
      setInfo({ count: stats.count, hasPending: stats.count > 0 });
    } catch {
      // Silently ignore — stats are best-effort
    }
  }, [db]);

  useEffect(() => {
    if (!db) return;

    poll();
    intervalRef.current = setInterval(poll, POLL_INTERVAL_MS);
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [db, poll]);

  return info;
}
